import {
  OBTENER_RUTAS,
  OBTENER_RUTAS_EXITO,
  OBTENER_RUTAS_ERROR,
  COMENZAR_EDICION_RUTA,
  RUTA_EDITADO_EXITO,
  RUTA_EDITADO_ERROR,
  RESET_EDICION_RUTA,
} from "../types";

// cada reducer tiene su propio state
const initialState = {
  rutas: [],
  error: false,
  errorMessage: null,
  loading: false,
  loadingUpdate: false,
  data: null,
};

function rutasReducer(state = initialState, action) {
  switch (action.type) {
    case OBTENER_RUTAS:
      return {
        ...state,
        loading: action.payload,
      };
    case OBTENER_RUTAS_EXITO:
      return {
        ...state,
        loading: false,
        error: null,
        rutas: action.payload,
      };
    case OBTENER_RUTAS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        errorMessage: action.payload.message,
      };
    case COMENZAR_EDICION_RUTA:
      return {
        ...state,
        loadingUpdate: action.payload,
        data: null,
      };
    case RUTA_EDITADO_EXITO:
      return {
        ...state,
        loadingUpdate: false,
        error: false,
        errorMessage: null,
        data: action.payload,
        rutas: state.rutas.map((ruta) =>
          ruta.id === action.payload.ruta.id ? action.payload.ruta : ruta
        ),
      };
    case RUTA_EDITADO_ERROR:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload.error,
        errorMessage: action.payload.message,
        data: null,
      };
    case RESET_EDICION_RUTA:
      return {
        ...state,
        error: false,
        errorMessage: null,
        loadingUpdate: false,
        data: null,
      };
    default:
      return state;
  }
}

export default rutasReducer;
